
export default {
  "m": {
    "sms_login": "SMS girişi",
    "get_vercode": "Gönder",
    "change_mobile": "Telefon numarasını değiştir",
    "log_reg_agree": "Oturum Aç/Kayıt Ol, {msg_ss} kabul etmek anlamına gelir",
    "old_mobile": "Eski telefon numarası",
    "new_mobile": "Yeni telefon numarası",
    "agency_reginfo_fill": "Lonca kayıt bilgilerini doldurun",
    "audit_res": "Denetim sonuçları",
    "agency_name": "Dernek ismi",
    "agency_name_input": "Lütfen bir lonca adı girin",
    "agency_name_input_note": "Not: Lonca adının kısa ve hatırlanması kolay olması, 30 kelimeyi geçmemesi önerilir.",
    "agency_logo": "Lonca LOGOSU",
    "agency_logo_unpload_note": "Lütfen PNG/JPG/JPEG formatında net bir lonca logosu yükleyin",
    "agency_contact_name": "Lonca bağlantısı",
    "user_contact_name": "Lütfen kullanıcı platformu ile günlük iletişimde olan kişinin adını giriniz.",
    "agency_contact_phone": "Lonca iletişim numarası",
    "agency_whatsapp": "Lonca  WhatsApp Numarası",
    "agency_whatsapp_contact": "Lütfen lonca liderinin WhatsApp iletişim bilgilerini giriniz.",
    "agency_use_lang": "Lonca tarafından kullanılan dil",
    "agency_head_ID": "Lonca Lideri Kimliği",
    "agency_ID_input": "Lütfen daha sonra fon dağıtımı için lonca lideri BuzzCast APP'nin kullanıcı kimliğini girin",
    "reg_country": "Kayıt ülkesi",
    "inhand_ID_photo": "Kimliğin fotoğrafı",
    "upload_note_t": "Notları Yükle",
    "agency_self_inhand_ID": "Lonca lideri pasaportu ile fotoğrafı çekmelidir.",
    "photo_must_clearly": "Ön yüz, kişiyi ve gerçek pasaport bilgilerini açıkça göstermelidir.",
    "mian_form_country": "Yayıncının ana kaynak ülkesi",
    "invite_code": "Davet Kodu",
    "your_profile_submit_success": "Belgeniz başarıyla gönderildi! en kısa sürede ilgileneceğiz.<br>Denetim sonuçları lonca liderinin BuzzCast APP bildirimine gönderilecek ve lütfen kontrol etmeye dikkat edin!",
    "your_profile_approved": "Gönderdiğiniz bilgiler onaylanmadı! Red sebebi ise \"pasaport fotoğrafının net olmaması\".<br>Lütfen yeniden doldurun veya danışma için BuzzCastAPP'deki resmi asistanla iletişime geçin.",
    "return_refill": "Yeniden doldurmak için",
    "success_agency": "Platforma başarılı girişiniz için tebrikler, çalışmaya başlamak için [tıklayın]!",
    "personal_account": "Kişisel hesap",
    "my_agency": "Benim Loncam",
    "your_agency_been_forcibly": "Loncanız platform tarafından zorla sonlandırıldı ve artık sisteme giriş yapamayacaksınız. Herhangi bir sorunuz varsa, lütfen BuzzCastAPP'nin resmi asistanı veya özel operasyon ile iletişime geçin.",
    "invite_live_join": "Yayıncıyı lonca bağlantısına katılmaya davet et",
    "base_info": "Temel Bilgiler",
    "apply_time": "Başvuru Tarihi",
    "join_time": "Giriş Zamanı",
    "cooper_status": "İşbirliği Durumu",
    "streamer_manage": "Yayıncı Yönetimi",
    "sereamer_apply": "Yayıncı Onayı",
    "sereamer_nickname": "Yayıncı Adı",
    "remark": "Açıklama",
    "no_remark": "Açıklama Yok",
    "add_remark": "Not Ekle",
    "birth": "Doğum Tarihi",
    "user_status": "Kullanıcı Durumu",
    "temporarily_frozen": "Geçici Dondurma",
    "permanently_frozen": "Sonsuza kadar donduruldu",
    "fans_num": "Hayran Sayısı",
    "sign_status": "Sözleşme Durumu",
    "sign_ing": "Sözleşmeli",
    "sign_time": "Sözleşme Tarihi",
    "release_time": "İptal Tarihi",
    "live_viola_record": "Canlı yayın ihlal kayıtları",
    "sign_record": "Sözleşme kaydı",
    "current_contract_status": "Mevcut sözleşme durumu",
    "termination_reason": "Fesih Nedeni",
    "violation_reason": "İhlal Nedeni",
    "violation_time": "İhlal Süresi",
    "processing_result": "Süreç Sonucu",
    "exported_data": "Verileri dışa aktar",
    "join_agency_apply": "Ajansa katılma onayı",
    "audit_status": "Onay Durumu",
    "pending_review": "Bekleyen yorum",
    "pending_HQ_review": "Karargah incelemesi bekleniyor",
    "not_approved_HQ": "Genel merkez denetimi başarısız oldu",
    "withdrawn": "İptal edildi",
    "audit_trail": "Denetim kayıtları",
    "oper": "Işletmek",
    "other_video_materials": "Diğer video materyali",
    "pass": "Onaylandı",
    "pass_streamer_join_agency_apply": "Yayıncının luncaya katılma talebi onaylandı",
    "reject_streamer_join_agency_apply": "Yayıncının luncaya katılma talebi onaylandı",
    "agree_streamer_join_agency": "Yayıncı{msg_ss1} {msg_ss2} ajansın ekibine geçme talebi onaylandı",
    "reject_streamer_join_agency": "Yayıncı {msg_ss1} {msg_ss2} ekibine geçme talebi reddedildi.",
    "img_material": "Resim Malzemesi",
    "approver": "Onaylayan",
    'user_enter_bind_phone': 'Lütfen telefon numarasını girin',
    'vericode': 'Doğrulama kodu',
    'input_vericode': 'Doğrulama kodu girin',
    'login': 'Oturum aç',
    'reg': 'Kayıtlı',
    'logout': 'Oturum aç',
    'search_for': 'Arama',
    'subscription_closed': 'İptal edilen sözleşme',
    'agency_ID': 'Lonca kodu: {msg_ss}',
    'reset': 'Sıfırla',
    'live_ID': 'Bağlantı kimliği',
    'live_record': 'Live ekran kaydı',
    'email': 'Posta',
    'phone': 'Telefon numarası',
    'mastery_lang': 'Dil ustalığı',
    'to': 'Için',
    'cancel': 'İptal',
    'Confirm': 'Onayla',
    'preview': 'Önizleme',
    'rejected': 'Reddedildi',
    'tip': 'İpucu',
    'i_got_it': 'Anladım',
    'cancelled': 'İptal edildi',
    'refused': 'Reddet',
    'agency_agree': 'Lonca kabul etti',
    'platform_agree': 'Platform kabul etti',
    'user_not_exist': 'Böyle bir kullanıcı yoktur',
    'user_frozen': 'Kullanıcı donduruldu',
    'reviewing': 'İnceleniyor',
    'review_pass': 'İnceleme geçti',
    'review_failed': 'İnceleme başarısız oldu',
    'xx_hours': '{msg_ss} saat',
    'xx_days': '{msg_ss} gün',
    'xx_hour': '{msg_ss} saat',
    'xx_day': '{msg_ss} gün',
    'xx_year': '{msg_ss} yıl',
    'xx_years': '{msg_ss} yıl',
    'check_phone_istrue': 'Lütfen telefon numarasının doğru girilip girilmediğini kontrol edin',
    'male': 'Erkek',
    'female': 'Kadın',
    'avatar': 'Portre',
    'normal': 'Normal',
    'live_room': 'Yayın odası',
    'view': 'Görüntüle',
    'oper_success': 'Operasyon başarılı oldu',
    'copy_success': 'Başarıyla kopyala',
    'new_mobile_already_reg': 'Yeni cep telefonu numarası kaydedildi',
    'general_user': 'Genel Kullanıcı',

    'copy': 'Kopya',
    'gender': 'Cinsiyet',
    'submit': 'Gönder',
    'permanent': 'Kalıcı',
    'agree_agreement': 'Kabul et ve sözleşmeye uy',
    'vericode_error': 'Doğrulama kodu hatalı',
    'resend': 'Yeniden Gönderme',
    'approved': 'Geçti',
    'not_approved': 'Geçmedi',
    'agency_rejected': 'Reddedildi',
    'select': 'Seç',
    'search': 'Arama',
    'rejection_reason': 'Reddedilme nedeni',
    'no_data': 'Veri boş',
    'oper_failed': 'Operasyon başarısız',
    'leave_agency_apply': 'Ajanstan ayrılma onayı',
    'over_word_limit': 'Kelime sınırını aştı',
    'delete': 'Sil',
    'nickname': 'Takma',
    'file_is_too_large': 'dosya çok büyük',

    'community_convention': 'Buzzcast Topluluk Sözleşmesi',
    'approval_time': 'İşlem süresi',
    'guild_system_title': 'BuzzCast sosyal platform lonca sistemi',
    'return': 'Dönüş',
    'img_upload_fail': 'Resim yüklenemedi',
    'cooper_ing': 'İşbirliği içinde',
    'upload_file_format_incorrect': 'Yüklenen dosya doğru biçimde değil',
    'token_invalid': 'Jeton geçersiz, lütfen tekrar giriş yapın!',
    'network_busy': 'Ağ meşgul, lütfen tekrar deneyin',
    'minute': '{msg_ss}dak',

    'live_room_ID': 'Yayın odası ID',
    'scan_code': 'BuzzCast APP giriş yapmak için kodu tara',
    'open_code': 'BuzzCastApp\'i açın, taramak için QR kodumatıklayın',
    'refresh': 'Yenileme',
    'login_confirm': 'Giriş onayı',
    'account': 'Hesap Bilgileri',
    'user_name': 'Kullanıcı adı',
    'edit': 'Tekrar düzeltme yapmak',
    'changing': 'Bağlayıcıyıdeğiştirme',
    'mobile_number': 'Telefon hesabı',
    'mobile_login': 'Cep numaranız {msg_ss} ile giriş yapabilirsiniz',
    'appId_login': 'AppID [{msg_ss}] olan hesabı taramak ve girişyapmak için kullanabilirsiniz.',
    'code_login': 'Eğer BuzzCast ve AppID bağlı değil ise, bağlandıktan sonra, giriş yapmak için kodu taramak için QR kodunukullanabilirsiniz',
    'verification_log': 'Eğercep telefonu numarası bağlı değil ise, bağlandıktan sonra giriş yapmak için cep telefonu numarasını ve doğrulama kodunu kullanabilirsiniz.',
    'binding_success': 'Bağlamabaşarılı',
    'binding_mobile': 'Cep telefonu numarasını bağlama',
    'edit_name': 'Kullanıcı adını değiştirme',
    'binding_alert': 'Bağlamalarıdeğiştirmek için ipuçları',
    'new_appId': 'Doğrudanyeni APPID tarama kodu bağlamasını kullanın,orijinal APPID doğrudan değiştirilecektir',
    'binding_account': 'BuzzCastApp hesabını bağlama',
    'anchor_earings': 'Çapa geliri',
    'signing_date': 'Sözleşme tarihi',
    'statistical_date': 'İstatistik tarihi',
    'valid_min': 'Toplam etkili süre (dakika)',
    'valid_day': 'Geçerli günler (günler)',
    'total_revenue': 'Toplam gelir',

    'bind': 'Bağla',
    'please_agree_agree': 'Lütfen anlaşmayı kabul edin',
    'note': 'Not: Bu sistem tarafından görüntülenen saat New York saatidir (EST)',
    'app_phone': 'APP\'nin cep telefonu numarasını kaydedin',
    'host_num': 'Ev sahibi sayısı',
    'enter_host_num': 'Lütfen tüm ana bilgisayarların numarasını girin',
    'platform': 'Işbirliği platformu',
    'statement': 'Aylık banka ekstresi',
    'enter_income': 'Lütfen ortalama aylık geliri giriniz',
    'check_commas': 'Yanlış biçim. Lütfen birden çok platformun virgülle ayrılıp ayrılmadığını kontrol edin',
    'submit_success': 'Belgeniz başarıyla gönderildi! en kısa sürede ilgileneceğiz',
    'usd': 'Dolar',
    'many_platforms': 'Lütfen daha önce işbirliği yaptığınız canlı yayın platformunu 20 platforma kadar giriniz',
    'limit_platform': '20 platforma kadar',
    'user_has_delete': 'Kullanıcı iptal edildi',
    'cant_commit': 'Zaten sözleşmeli bir yayıncısınız ve aynı zamanda yerleşmek için bir loncaya başvuramazsınız',
    'cant_commit_1': 'Halihazırda anlaşmalı bir yayıncıya başvurdunuz ve aynı zamanda yerleşmek için bir lonca başvurusunda bulunamazsınız',
    'passwd': 'Şifre',
    'passwd_placeholder': 'Parolanız 6 ila 20 karakter içermelidir',
    'live_rights': 'Zamansız değerlendirme',
    'edit_log': 'Kaydı değiştir',
    'edit_time': 'Zamanı Değiştir',
    'edit_pwd': 'Şifre değiştir',
    'old_pwd': 'Eski Şifre',
    'new_pwd': 'Yeni Şifre',
    'confirm_pwd': 'Şifreyi Onayla',
    'forget_pwd': 'Şifreyi unuttun mu?',
    'email_check': 'E-posta biçimi yanlış',
    'phone_pwd_error': 'Yanlış Telefon Numarası veya Şifre',
    'ten_min_error': 'Lütfen 10 dakika deneyin',
    'phone_bind_error': 'Cep telefonu numarası başka hesaplara bağlanmıştır, lütfen bağlamak için yeni cep telefonu numarasını değiştirin.',
    'bc_user_id_tip': 'Buzzcast APP ID',
    'bc_user_id_error': 'Klan lideri ID zaten doldurulmuş, lütfen tekrar doldurun',
    'pwd_error': 'Parola hatası',
    'phone_not_reg_error': 'Hesap kayıtlı değil',
    'pwd_nq': 'Şifre bir öncekiyle tutarsız',
    'sign_anchor_error': 'Zaten sözleşmeli bir yayıncısınız ve aynı zamanda yerleşmek için bir loncaya başvuramazsınız',
    'apply_anchor_error': 'Halihazırda anlaşmalı bir yayıncıya başvurdunuz ve aynı zamanda yerleşmek için bir lonca başvurusunda bulunamazsınız',
    'have-expired': 'Günü geçmiş',
    'approval-time': 'İşlem süresi',
    'reasons-for-refusal': 'Lütfen reddetme nedenini girin',
    'Transfer-grounds': 'Transfer sebebi:',
    'code_expire': 'Doğrulama kodunun süresi doldu, yenilemek için lütfen üzerine tıklayın',
    'transfer-approval': 'Transfer onayı',
    'live_state_placeholder': 'Canlı yayın durumu',
    'live_state_open': 'Normal',
    'live_state_temporary_banned': 'Yayın yasağı',
    'live_state_forever_banned': 'Kalıcı olarak yasaklandı',
    'live_allowed_time': 'İzin verilen başlangıç saatleri',
    'live_banned_time': 'Yasaklama döngüsü',
    'deduct_money': 'Düşülen B Madeni Para Miktarı',
    'final_income': 'Gerçek Kazanç',
    'select_start_dt': 'Lütfen başlangıç saatini seçin',
    'select_end_dt': 'Lütfen bitiş saatini seçin',
    'less_then_end_dt': 'Başlangıç saati bitiş saatinden küçük veya ona eşit olmalıdır',
    'System_automatically_through': 'Sistem otomatik olarak geçer',
    'btrade_err': 'Lonca kimliği mevcut değil',

    'mouth_anchor': 'Aylık Maaş canlı yayın yapan kişi',
    'day_anchor': 'Günlük ücret çıpası',
    'guild_anchor': 'Lonca Başkanı Teşviki (harcırah)',
    'mouth_anchor_st': 'Aylık maaş başlama zamanı',
    'mouth_anchor_et': 'Aylık maaşın bitiş saati',
    'day_anchor_st': 'Günlük ücretin başladığı saat',
    'day_anchor_et': 'Günlük maaş bitiş saati',
    'all_award_bcoin': 'Günlük maaş ödülü toplam geliri',
    'live_hour': 'Canlı yayın geçerli süre ödülü',
    'salary_day': 'tarihler',
    'day_in_come': 'Loncanın günlük geliri(B coin）',
    'award_ration_flag_str': 'Ödül oranı',
    'payable_money': 'Lonca lideri B coin ödülü',
    'host_bcoins': 'canlı yayın yapan kişi elde ettiği Bcoin',
    'total_official': 'Toplam resmi Bcoin ödülleri',
    'actual_bcoins_awarded': 'Gerçek Ödül B coin',
    "change_bound_account":"Bağlı hesabı değiştir" ,
    "agent_id_form":"Lonca Lideri Kimliği:" ,
    "BuzzCast_verification_code":"BuzzCast doğrulama kodu:" ,
    "send_success":"Başarıyla gönderildi" ,
    "account_changed_successfully":"Bağlı hesap başarıyla değiştirildi." ,
    "invite_guild_url":"BuzzCast lonca lideri olmak için davet bağlantısı: {msg_ss}" ,
    "invite_guild_code":"Davet kodum: {msg_ss}" ,
    "save":"Kaydetmek" ,
    "compile":"Düzenle" ,
    "agent_nvitation_eward":"Lonca lideri davet ödülü" ,
    "agent_name":"Lonca liderinin takma adı" ,
    "guild_id":"Lonca kodu" ,
    "guild_income_30days":"Son 30 gündeki lonca geliri" ,
    "guild_invite_income_30days":"Son 30 gün içinde davet edilen loncalardan elde edilen gelir" ,
    "agency_commission_ratio":"Acente Komisyon Oranı" ,
    "invite_income_bcoins":"Davet ödülleri B coin" ,
    "id_not_exist": "Kimlik yok",
    'reward_distribution_status': 'Ödül dağıtım durumu',
    'must_number': 'Girişiniz tamamen sayısal formatta olmalıdır.',


  },
}



// WEBPACK FOOTER //
// ./src/i18n/lang/tr.js